import type { CSSProperties } from 'react';
import type { BetBurst } from './betBurstModel';
import { PointsUnit } from '../PointsAmount';

export function BetBursts({ bursts }: { bursts: BetBurst[] }) {
  return (
    <span className="bet-bursts" aria-hidden="true">
      {bursts.map((burst) => (
        <span
          className={
            'bet-burst ' + (burst.side === 'DIE' ? 'is-down' : 'is-up')
          }
          key={burst.id}
          style={
            {
              top: (burst.top / 64) * 100 + '%',
              [burst.side === 'DIE' ? 'left' : 'right']: burst.inset + 'px',
              '--bet-ms': burst.ms + 'ms',
              '--bet-delay': burst.delay + 'ms',
              '--bet-rotation': burst.rotation + 'deg',
            } as CSSProperties
          }
        >
          <span className="bet-flight" style={{ offsetPath: burst.path }}>
            +{burst.amount ?? burst.count}
            {burst.amount !== null ? (
              <PointsUnit />
            ) : (
              <small>{burst.count === 1 ? 'bet' : 'bets'}</small>
            )}
          </span>
        </span>
      ))}
    </span>
  );
}
